import { api } from '../lib/api';
import { Badge, Loading, useAsync } from '../components/common';

export default function SnowflakePage() {
  const { data, error, loading } = useAsync(() => api.listSnowflakeProfiles(), []);
  if (loading || !data) return <Loading error={error} />;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Snowflake profiles</h1>
          <p>
            Every physical object is stored explicitly. Table names are not derivable by swapping a
            schema — <code>LEAD_CLIENT_TABLE</code>, <code>JW_LEAD_CLIENTS</code> and{' '}
            <code>MLG_LEAD_CLIENTS</code> genuinely differ, so a <code>{'{schema}'}</code> template
            would silently produce a query against a table that does not exist.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Profile</th>
                <th>Schema</th>
                <th>Client</th>
                <th>Creditor</th>
                <th>Transactions</th>
                <th>Escrow balance col</th>
                <th>DS account / routing</th>
                <th>Exists</th>
              </tr>
            </thead>
            <tbody>
              {data.map((p) => (
                <tr key={p.profile_key}>
                  <td>
                    <code>{p.profile_key}</code>
                    <div className="small muted">{p.role}</div>
                  </td>
                  <td className="mono small">{p.schema_name}</td>
                  <td className="mono small">{p.client_table ?? '—'}</td>
                  <td className="mono small">{p.creditor_table ?? '—'}</td>
                  <td className="mono small">{p.txn_table ?? '—'}</td>
                  <td className="mono small">{p.escrow_balance_col}</td>
                  <td className="mono small">
                    {p.ds_acc_col} / {p.ds_routing_col}
                  </td>
                  <td>
                    {p.exists_in_snowflake ? (
                      <Badge tone="ok">yes</Badge>
                    ) : (
                      <Badge tone="warn">not created</Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="small muted" style={{ marginBottom: 0 }}>
          The profile key is a cross-service contract: SM3 sends it to the true-escrow service as{' '}
          <code>source</code>, so renaming one breaks a call that has no compile-time link to this
          table.
        </p>
      </div>
    </>
  );
}
